module.exports = __webpack_public_path__ + "static/design-systems2x-1a4a685b373fe0082e295d35dbcf8536.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/design-systems2x.png
// module id = 2682
// module chunks = 157636680307020